module.exports = __webpack_public_path__ + "static/media/happyNewYear.f7f17497.png";